export default __webpack_public_path__ + "static/paleto_bay_lockup-2f28ef317ed79e3e455f33ad0aed6861.png";